import {del, get as httpGet, patch, post} from '../../../api';
import create from 'zustand'
const useLinks = create((set, get)=>{
  return {
    links:[],
    loadLinks:()=>{
      return httpGet('/linkbox').then((data)=>{
        set({
          links: data.links
        })
      })
    },
    deleteLink:(id)=>{
      set({
        links: get().links.filter((i)=>i.id != id)
      })
      return del('/linkbox/'+id).then(()=>{
      })
    },
    patchLinks:(id, isFavorite)=>{
      set({
        links: get().links.map((i)=>i.id == id ? {...i, isFavorite} : i)
      })
      return patch('/linkbox/' + id, {
        isFavorite
      }).then(()=>{

      })
    },
    createLink:(url, type)=>{
      return post('/linkbox/',{
        url, type
      }).then((data)=>{
        set({
          links: [data, ...get().links]
        })
      })
    }
  }
})

export default useLinks
